import React from "react";
import Sidebar from "../Dashboard/Sidebar";

function Viewrevenue()
{
    return(
        <>
    
        <h2>View Revenue</h2>
        </>
    )
}
export default Viewrevenue;